"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapEnumerated = exports.enumerated = exports.map = exports.char = exports.noEmptyString = exports.string = exports.int = exports.float = exports.bool = exports.decodeValue = void 0;
const errors_1 = require("./errors");
const decodeValue = (value) => _ => value;
exports.decodeValue = decodeValue;
const bool = json => {
    if (typeof json === 'boolean') {
        return json;
    }
    throw new errors_1.DecodeError(`Expected boolean, got ${JSON.stringify(json)}`);
};
exports.bool = bool;
const float = json => {
    if (typeof json === 'number') {
        return json;
    }
    throw new errors_1.DecodeError(`Expected number, got ${JSON.stringify(json)}`);
};
exports.float = float;
const isInteger = value => Number.isFinite(value) && Math.floor(value) === value;
const int = json => {
    if (typeof json === 'number' && isInteger(json)) {
        return json;
    }
    throw new errors_1.DecodeError(`Expected integer, got ${JSON.stringify(json)}`);
};
exports.int = int;
const string = json => {
    if (typeof json === 'string') {
        return json;
    }
    throw new errors_1.DecodeError(`Expected string, got ${JSON.stringify(json)}`);
};
exports.string = string;
const noEmptyString = json => {
    if (typeof json === 'string' && json.length > 0) {
        return json;
    }
    throw new errors_1.DecodeError(`Expected no empty string, got ${JSON.stringify(json)}`);
};
exports.noEmptyString = noEmptyString;
const char = json => {
    if (typeof json === 'string' && json.length === 1) {
        return json;
    }
    throw new errors_1.DecodeError(`Expected single-character string, got ${JSON.stringify(json)}`);
};
exports.char = char;
const map = (decode, f) => json => f(decode(json));
exports.map = map;
const enumerated = values => {
    return (0, exports.map)(exports.string, function (result) {
        if (values.includes(result)) {
            return result;
        }
        throw new errors_1.DecodeError(`Expected one of [${values.join(', ')}], got ${JSON.stringify(result)}`);
    });
};
exports.enumerated = enumerated;
const mapEnumerated = enumMap => json => enumMap[(0, exports.enumerated)(Object.keys(enumMap))(json)];
exports.mapEnumerated = mapEnumerated;
//# sourceMappingURL=basicDecode.js.map